import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M9.26 9.26 3 11v3l14.14 3.14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 15.34V6l-7.31 2.03", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MegaphoneOff";
const MegaphoneOff = memo(themed(Icon));
export {
  MegaphoneOff
};
//# sourceMappingURL=megaphone-off.js.map
